export default __webpack_public_path__ + "static/media/Lateef.1784c62b.woff2";